// @flow

// Rather than plumbing the same parameters through all Closeup,
// CloseupContainer provides a FeaturedCommentProvider to pass down to children components
// This context isn't required since not all uses of comments have FeaturedComments
// (such as Tried It)
import React, { createContext, useContext, type AbstractComponent } from 'react';

export type FeaturedCommentContextType = {
  featuredCommentId?: string,
};

const context = createContext<?FeaturedCommentContextType>(null);

// Provider
export const FeaturedCommentProvider = context.Provider;

// HOC
export function withFeaturedComment<Config: {}>(
  Subject: AbstractComponent<Config>,
): AbstractComponent<$Diff<Config, FeaturedCommentContextType>> {
  const hoc = (props) => {
    // this is a stateless functional component but eslint failing
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const featuredComment = useContext(context);

    return <Subject {...props} {...featuredComment} />;
  };

  hoc.displayName = `FeaturedCommentContext(${String(Subject.displayName || Subject.name)})`;

  return hoc;
}

// Render Prop
export const FeaturedComment = context.Provider;

// Hook
export function useFeaturedComment() {
  const featuredComment = React.useContext(context);

  return featuredComment;
}
